<template>
  <v-container id="impuestos" tag="section">
    <base-v-component heading="Impuestos del sistema " />
    <base-material-card color="indigo" icon="mdi-currency-eur" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{formTitle}}</v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row wrap>
                  <v-col xs12 sm6>
                    <v-text-field v-model="nombre" label="Nombre" :error-messages="nombreErrors"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="impuesto"
                      type="number"
                      step="0.01"
                      label="Impuesto"
                      :error-messages="impuestoErrors"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="loadingForm">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <v-data-table :headers="headers" :items="impuestos" :loading="loading" :search="search">
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-btn class="px-2 ml-1" color="success" min-width="0" small>
              <v-icon small @click="editItemDialog(item)">mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="px-2 ml-1" color="red" min-width="0" small>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, decimal } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations: {
    nombre: { required, minLength: minLength(2) },
    impuesto: { required, decimal }
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      dialog: false,
      search: "",
      nombre: "",
      impuesto: 0,
      headers: [
        {
          sortable: false,
          text: "Cantidad",
          value: "cantidad"
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombre"
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right"
        }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.isEdit ? "Editar Impuesto" : "Nuevo Impuesto";
    },
    ...mapState({
      //impuestos : (state) => state.impuestos.impuestosArray
    }),
    ...mapGetters({
      impuestos: "impuestos/getImpuestosListado"
    }),
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio");
      !this.$v.nombre.minLength && errors.push("Nombre demasiado corto");
      return errors;
    },
    impuestoErrors() {
      const errors = [];
      if (!this.$v.impuesto.$dirty) return errors;
      !this.$v.impuesto.required && errors.push("Impuesto es obligatorio");
      !this.$v.impuesto.decimal && errors.push("Impuesto debe ser un número");
      return errors;
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.nombre = "";
      this.impuesto = 0;
      this.id = null;
    },
    reload() {
      this.getImpuestos();
    },
    editItemDialog(item) {
      this.nombre = item.nombre;
      this.id = item.id;
      this.impuesto = item.impuesto;
      this.showDialog();
    },
    addImpuesto() {
      let i = {
        impuesto: this.impuesto,
        nombre: this.nombre,
        id: this.id
      };
      return this.$store.dispatch("impuestos/addImpuesto", i);
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addImpuesto()
            .then(res => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Impuesto grabado con éxito"
              });
              _vm.getImpuestos();
              _vm.dialog = false;
            })
            .catch(error => {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar el impuesto: " + error
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    },
    getImpuestos() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("impuestos/getImpuestos").finally(() => {
        _vm.loading = false;
      });
    },
    deleteItem(item) {
      let r = confirm("¿Quieres eliminar el impuesto? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("impuestos/deleteImpuesto", item)
          .then(res => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Impuesto eliminado"
            });
            _vm.getImpuestos();
          })
          .catch(error => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar: " + error
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    }
  }
};
</script>